import React from 'react'
import classNames from 'classnames'
import ClearIcon from '@material-ui/icons/Clear'
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import Tooltip from '@material-ui/core/Tooltip'
import SearchIcon from '@material-ui/icons/Search'
import TextField from '@material-ui/core/TextField'
import { Box } from '@material-ui/core'
import * as propTypes from 'prop-types'
import { isEmpty } from 'lodash'

const TableSearchBar = ({
  classes,
  enableMultiSearch,
  searchValue,
  onChange,
  onSearchValueChange,
  filterData,
  saveFilterValue,
  saveSearchQuery,
  onClear,
  showSearchIcon = true,
  inputRef,
}) => {
  const [searchOpen, setSearchOpen] = React.useState(false)

  const handleChange = (event) => {
    let filterValue = event.target.value
    let searchQuery = filterValue
    if (enableMultiSearch) {
      try {
        searchQuery = filterValue
          ?.replace(/[/+//()/[\\]/g, '\\$&')
          ?.trim()
          .split(/[\,\r\n]+/g)
          ?.filter(String)
        const wholeString = searchQuery?.join(' ')
        searchQuery.unshift(wholeString)
      } catch (e) {
        console.log('Error in special character search', e)
      }
    }
    if (saveSearchQuery) saveSearchQuery(searchQuery)
    if (onSearchValueChange) onSearchValueChange(filterValue)
    if (filterData) filterData(searchQuery)
    if (saveFilterValue) saveFilterValue(filterValue)
    if (onChange) onChange(event)
  }

  return (
    <Box
      className={classNames(classes.expand, {
        [classes.searchExtended]: enableMultiSearch,
      })}
    >
      {showSearchIcon && (
        <Tooltip
          style={{
            display: searchOpen === false ? 'block' : 'none',
            float: 'right',
          }}
          title="Search list"
        >
          <IconButton
            aria-label="Search list"
            onClick={() => setSearchOpen(true)}
          >
            <SearchIcon />
          </IconButton>
        </Tooltip>
      )}
      <TextField
        data-cy="searchText"
        placeholder="Search"
        fullWidth
        multiline
        value={searchValue}
        onChange={handleChange}
        style={{
          display: searchOpen || !isEmpty(searchValue) ? 'inline' : 'none',
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="Clear search"
                onClick={() => {
                  setSearchOpen(false)
                  if (onClear) onClear()
                }}
                data-cy="clearSearch"
              >
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        inputRef={inputRef}
      />
    </Box>
  )
}

TableSearchBar.propTypes = {
  classes: propTypes.object,
  enableMultiSearch: propTypes.bool,
  searchOpen: propTypes.bool,
  searchValue: propTypes.string,
  onChange: propTypes.func,
  onSearchValueChange: propTypes.func,
  filterData: propTypes.func,
  saveFilterValue: propTypes.func,
  saveSearchQuery: propTypes.func,
  onClear: propTypes.func,
  showSearchIcon: propTypes.bool,
  inputRef: propTypes.object,
}

export default TableSearchBar
